import { render, staticRenderFns } from "./SensorHeader.vue?vue&type=template&id=4edd7046&scoped=true&"
import script from "./SensorHeader.vue?vue&type=script&lang=ts&"
export * from "./SensorHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SensorHeader.vue?vue&type=style&index=0&id=4edd7046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd7046",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VExpansionPanelHeader,VIcon,VImg})
